<template>
    <el-dialog
        title="预警处理"
        width="780px"
        :visible.sync="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @closed="$emit('closed')">
        <el-form ref="form" :model="formData" :rules="rules" label-width="auto">
            <el-form-item label="预警类型：">
                {{ rowData.__warningTypeName__ }}
            </el-form-item>

            <el-form-item prop="isDisposeAbnormal" label-width="0">
                <el-radio-group v-model="formData.isDisposeAbnormal">
                    <el-radio label="0">有异常</el-radio>
                    <el-radio label="1">无异常</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item prop="remark" label-width="0">
                <el-input
                    v-model="formData.remark"
                    :maxlength="100"
                    :autosize="{ minRows: 2, maxRows: 6 }"
                    type="textarea"
                    resize="vertical"
                    placeholder="请输入备注"
                    show-word-limit
                    clearable />
            </el-form-item>

            <el-form-item label-width="0">
                <h4>以下为同一发车单下同一类型的未处理预警，勾选后支持批量处理</h4>
                <el-table
                    v-loading="tableLoading"
                    ref="tableRef"
                    :data="tableData"
                    style="width: 100%"
                    border
                    max-height="240px"
                    @selection-change="handleSelection"
                    @row-click="handleRowClick">
                    <el-table-column type="selection" fixed="left"></el-table-column>
                    <el-table-column prop="warningTime" label="预警时间" sortable width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="warningReason" label="预警原因" sortable show-overflow-tooltip></el-table-column>
                </el-table>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { handleWarningData } from '@/modules/transport/otp/api/collusionWarningMap';
import { makeRequiredRule, makeValidatorRule } from '@/modules/transport/otp/utils/makeRules';
import { queryWarningDataByTypeApi } from '@/modules/transport/otp/api/collusionWarning';
import { uniq, toString } from 'lodash';

export default {
    name: 'WarningHandleDialog',
    props: {
        rowData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            visible: true,
            btnLoading: false,
            tableLoading: false,
            selected: [],
            tableData: [],
            formData: {
                remark: '', // 备注
                isDisposeAbnormal: '' // 是否有风险
            },
            rules: {
                isDisposeAbnormal: [makeRequiredRule('请选择有无异常')],
                remark: [
                    makeRequiredRule('请输入备注'),
                    makeValidatorRule((rule, value, callback) => {
                        // 防止用户全部输入空格
                        const val = value.trim();
                        if (val.length === 0) {
                            callback(new Error('请输入备注'));
                        } else {
                            callback();
                        }
                    })
                ]
            }
        };
    },
    mounted() {
        this.queryTableData();
    },
    methods: {
        // 查询同一发车单下待处理的预警列表
        async queryTableData() {
            try {
                this.tableLoading = true;
                const res = await queryWarningDataByTypeApi({
                    dispatchNo: this.rowData.dispatchNo,
                    warningType: this.rowData.warningType
                });
                if (res && +res.code === 0) {
                    this.tableData = res.data || [];
                    // 默认全选
                    this.$refs.tableRef.clearSelection();
                    this.$refs.tableRef.toggleAllSelection();
                }
            } finally {
                this.tableLoading = false;
            }
        },

        // 提交
        async handleSubmit() {
            try {
                await this.$refs.form.validate();
                this.btnLoading = true;
                const selected = (this.selected || []).map(item => item.id);
                const { isDisposeAbnormal } = this.formData;
                const res = await handleWarningData({
                    isDisposeAbnormal: isDisposeAbnormal,
                    remark: [
                        toString(isDisposeAbnormal) === '0' ? '有异常' : '无异常',
                        this.formData.remark.trim()
                    ].join('，'),
                    idList: uniq([].concat(selected, this.rowData.id))
                });
                if (res && +res.code === 0) {
                    this.$message.success('成功!');
                    this.$emit('success');
                    this.close();
                }
            } finally {
                this.btnLoading = false;
            }
        },
        // 行点击
        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        },
        // 选择事件
        handleSelection(selection) {
            this.selected = selection || [];
        },
        close() {
            this.visible = false;
        }
    }
};
</script>

<style lang="less" scoped>
::v-deep .el-form-item {
    margin-bottom: 16px;

    .el-form-item__error {
        padding-top: 2px;
    }

    .el-form-item__label {
        padding-right: 4px;
    }

    .el-form-item__label,
    .el-form-item__content {
        line-height: 16px;
    }
}
</style>
